import React, { useRef, useState } from 'react';
import TemplateModern from '../templates/TemplateModern';
import TemplateClassic from '../templates/TemplateClassic';
import TemplateMinimal from '../templates/TemplateMinimal';
import { Printer, Download, Mail, CheckCircle, Loader } from 'lucide-react';
import { downloadInvoicePDF } from '../utils/pdfUtils';

const InvoicePreview = ({ invoiceData, templateComponent }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [emailStatus, setEmailStatus] = useState(''); // '', 'loading', 'success', 'error'

  const invoice = invoiceData.invoice || invoiceData.Invoice;
  const fileName = `INV_${invoice.invoiceNo || invoice.InvoiceNo}_${new Date().toISOString().split('T')[0]}.pdf`;

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = async () => {
    setIsProcessing(true);
    await downloadInvoicePDF('invoice-capture-area', fileName);
    setIsProcessing(false);
  };

  const handleSendEmail = async () => {
    setEmailStatus('loading');
    try {
      // 1. Generate PDF Base64
      const pdfBase64 = await downloadInvoicePDF('invoice-capture-area', fileName);
      
      // 2. Send to Backend
      const response = await fetch('/api/email/send-invoice', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          toEmail: invoice.billToEmail || 'client@example.com', // Would ideally have client email
          subject: `Invoice from Intechronix: ${invoice.invoiceNo}`,
          body: `<p>Dear Client,</p><p>Please find attached invoice <b>${invoice.invoiceNo}</b>.</p><p>Regards,<br/>Intechronix Team</p>`,
          pdfBase64: pdfBase64,
          fileName: fileName
        })
      });

      if (response.ok) {
        setEmailStatus('success');
        setTimeout(() => setEmailStatus(''), 3000);
      } else {
        throw new Error("Failed to send");
      }
    } catch (err) {
      console.error(err);
      setEmailStatus('error');
      alert("Check Email settings in appsettings.json. Make sure SMTP is configured.");
    }
  };

  const renderTemplate = () => {
    switch (templateComponent) {
      case 'TemplateModern': return <TemplateModern data={invoiceData} />;
      case 'TemplateClassic': return <TemplateClassic data={invoiceData} />;
      case 'TemplateMinimal': return <TemplateMinimal data={invoiceData} />;
      default: return <TemplateModern data={invoiceData} />;
    }
  };

  return (
    <div>
      <div className="no-print" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
        <h3 style={{ color: 'var(--text-muted)', margin: 0 }}>Invoice Preview</h3>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button onClick={handleDownload} className="btn-outline" style={{ width: 'auto', padding: '0.6rem 1.2rem', gap: '0.5rem' }} disabled={isProcessing}>
                {isProcessing ? <Loader className="animate-spin" size={18} /> : <Download size={18} />} 
                {isProcessing ? 'Processing...' : 'Download PDF'}
            </button>
            <button onClick={handleSendEmail} className="btn-outline" style={{ width: 'auto', padding: '0.6rem 1.2rem', gap: '0.5rem', color: emailStatus === 'success' ? 'var(--secondary)' : 'var(--primary)' }} disabled={emailStatus === 'loading'}>
                {emailStatus === 'loading' ? <Loader className="animate-spin" size={18} /> : (emailStatus === 'success' ? <CheckCircle size={18} /> : <Mail size={18} />)}
                {emailStatus === 'loading' ? 'Sending...' : (emailStatus === 'success' ? 'Sent!' : 'Email to Client')}
            </button>
            <button onClick={handlePrint} className="btn-primary" style={{ width: 'auto', padding: '0.6rem 1.5rem', gap: '0.5rem' }}>
                <Printer size={18} /> Print
            </button>
        </div>
      </div>

      <div id="invoice-capture-area" className="print-area" style={{ background: 'white' }}>
        {renderTemplate()}
      </div>
    </div>
  );
};

export default InvoicePreview;
